import { useEffect, useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { api } from "@/lib/api";

function PrivateImg({ incId, photo, i }) {
  const [src, setSrc] = useState(null);
  const [big, setBig] = useState(null);
  useEffect(() => {
    let url;
    api.get(`/incidents/${incId}/photos/${photo.id}?thumb=true`, { responseType: "blob" })
      .then((r) => { url = URL.createObjectURL(r.data); setSrc(url); }).catch(() => {});
    return () => url && URL.revokeObjectURL(url);
  }, [incId, photo.id]);
  const open = () => api.get(`/incidents/${incId}/photos/${photo.id}`, { responseType: "blob" })
    .then((r) => setBig(URL.createObjectURL(r.data))).catch(() => {});
  const close = () => { URL.revokeObjectURL(big); setBig(null); };
  return (
    <>
      <button type="button" onClick={open} data-testid={`incident-photo-${incId}-${i}`} className="h-20 w-20 overflow-hidden rounded-lg border border-white/10 bg-black/40">
        {src && <img src={src} alt="" className="h-full w-full object-cover" />}
      </button>
      <Dialog open={!!big} onOpenChange={(v) => !v && close()}>
        <DialogContent className="max-w-3xl border-white/10 bg-[#0f1015] p-2" aria-describedby={undefined} data-testid="incident-photo-dialog">
          {big && <img src={big} alt="" className="max-h-[80vh] w-full object-contain" />}
        </DialogContent>
      </Dialog>
    </>
  );
}

export function IncidentPhotos({ inc }) {
  if (!inc.photos?.length) return null;
  return <div className="mt-2 flex flex-wrap gap-2" data-testid={`incident-photos-${inc.id}`}>{inc.photos.map((p, i) => <PrivateImg key={p.id} incId={inc.id} photo={p} i={i} />)}</div>;
}
